// /var/www/aesirerp_lp/frontend/src/components/ScrollAnimator.tsx
'use client';

import { useEffect, useRef, useState } from 'react';

interface ScrollAnimatorProps {
  children: React.ReactNode;
  delay?: number; // Permite passar um delay opcional
  className?: string; // Permite passar classes extras
}

export function ScrollAnimator({ children, delay = 0, className = '' }: ScrollAnimatorProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Opcional: Desconectar se quiser que anime apenas uma vez
          if (ref.current) observer.unobserve(ref.current);
        }
      },
      {
        threshold: 0.1, // Dispara quando 10% do elemento aparece
        rootMargin: '0px 0px -50px 0px', // Um pouco antes de entrar totalmente
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`${className} ${isVisible ? 'animate-in' : 'opacity-0'}`}
      style={{ transitionDelay: `${delay}ms`, animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}